import config from "./config";
import { authenticationService } from "./authentication.service";
import { authHeader } from "./helpers";

function authenticationError() {
  const error = new Error("Please log in to view this report.");
  error.authenticationRequired = true;
  return error;
}

async function get(path, signal) {
  const session = authenticationService.currentUserValue;
  if (!session) throw authenticationError();
  if (!window._accessToken || Date.now() / 1000 >= session.expiry)
    await authenticationService.refreshToken();
  if (signal?.aborted) throw new DOMException("Request aborted", "AbortError");
  const headers = authHeader();
  if (!headers.Authorization) throw authenticationError();
  const response = await fetch(`${config.apiUrl}/${path}`, { signal, headers });
  if ([401, 403].includes(response.status)) throw authenticationError();
  if (!response.ok)
    throw new Error(
      response.status === 404
        ? "This report link is unavailable. It may have been removed."
        : "We could not load this report. Please try again.",
    );
  return response.json();
}

export const webReports = {
  report: (token, signal) =>
    get(`web-reports/${encodeURIComponent(token)}/`, signal),
  ownedReport: (id, signal) => get(`web-reports/owned/${id}/`, signal),
  collection: (token, signal) =>
    getCollection(`web-report-collections/${encodeURIComponent(token)}/`, signal),
  ownedCollection: (kind, id, signal) =>
    getCollection(`web-report-collections/owned/${kind}/${id}/`, signal),
};

async function getCollection(path, signal) {
  const first = await get(`${path}?limit=200`, signal);
  const results = [...first.results];
  for (let offset = results.length; offset < first.count; offset += 200) {
    const page = await get(
      `${path}?limit=200&offset=${offset}&include_summary=0`,
      signal,
    );
    results.push(...page.results);
  }
  return { ...first, results };
}
